$(document).ready(function () {
var ab = $(" #product-description p:nth-child(2)");
  if(ab.length === 0){
    $(".readmore").hide();
    $(".readless").hide();
  }
   // var p = $(" #product-description p:nth-child(1)").height();
   var p = $(" #product-description p").first().height();
   var description = document.querySelector(' #product-description');
   if(description){
    description.style.height = p+'px';
    $('.readmore').click(function (event) {
        event.preventDefault();
        $(this).hide();
        $(".readless").show();    
        description.style.height = 'auto';      
        // $(this).text($(this).text() == 'Read less...' ? 'Read More...' : 'Read less...');
    });
    $('.readless').click(function (event) {
        event.preventDefault();
        $(this).hide();
        $(".readmore").show();   
        // var p1 = $("#product-description p:first-child").height();
        var p1 = $(" #product-description p").first().height();
        description.style.height =  p1+'px';      
        // $(this).text($(this).text() == 'Read less...' ? 'Read More...' : 'Read less...');
    });
   }
  });
  $(window).scroll(function(){
  var ab = $(" #product-description p:nth-child(2)");
  if(ab.length === 0){
    $(".readmore").hide();
    $(".readless").hide();
  }
  });
 $(window).resize(function(){
  if ( $('.readmore').is(":visible") )
  {
  // var p = $(" #product-description p:first-child").height();
   var p = $(" #product-description p").first().height();
   var description = document.querySelector('#product-description');
   description.style.height = p+'px';
  }
  if ( $('.readless').is(":visible") )
  {  
   var description = document.querySelector('#product-description');
   description.style.height = 'auto';
  }

 
 });





